import GiftItem from "../GiftItem/GiftItem"
import styles from './Inventory.module.css'

const Inventory = () => {
    return (
        <div className={styles.inventoryGrid}>
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={2} allProgress={15} name="Мишка" />
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={2} allProgress={15} name="Мишка" />
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={2} allProgress={15} name="Мишка" />
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={2} allProgress={15} name="Мишка" />
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={2} allProgress={15} name="Мишка" />
            <GiftItem img="https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39"
                progress={15} allProgress={15} name="Мишка" />
        </div>
    )
}

export default Inventory